var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEsgColorLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 27 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7552 0.489074L26.4665 0.489014V3.20285L19.7552 3.20291C18.0622 3.20291 16.4904 4.08167 15.6038 5.52399L12.9199 9.88999C12.7244 10.208 12.5075 10.5084 12.2718 10.7898L19.7412 10.7898C19.7458 10.7898 19.7505 10.7898 19.7551 10.7898H26.4115V13.5036H19.7551C19.7514 13.5036 19.7476 13.5036 19.7439 13.5037C18.0551 13.5075 16.4884 14.3856 15.6037 15.8247L12.9198 20.1907C11.5394 22.4362 9.09235 23.8044 6.45644 23.8044H6.10352e-05L6.11538e-05 21.0905H6.45644C8.14948 21.0905 9.72119 20.2118 10.6078 18.7695L13.2917 14.4035C13.4872 14.0855 13.7041 13.7851 13.9399 13.5037L0.00059939 13.5037V13.5036H0.000157269L0.000157388 10.7898H6.45657C8.14962 10.7898 9.72133 9.91108 10.608 8.46876L13.2919 4.10276C14.6723 1.85721 17.1193 0.489074 19.7552 0.489074Z",
    fill: "url(#paint0_linear_79_870)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_79_870",
    x1: 3.311,
    y1: 12.1467,
    x2: 23.6442,
    y2: 12.1467,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#87E950"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#064254"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEsgColorLogo);
export default __webpack_public_path__ + "static/media/ESG-color-logo.0cb3a7385940497ad0be5d5b78677837.svg";
export { ForwardRef as ReactComponent };